import { Suspense, useEffect } from "react";

import DoOrDump from "@/components/DoOrDump";
import WaitlistLanding from "@/components/WaitlistLanding";
import { buildPreviewDoOrDumpDashboardPayload } from "@/lib/do-or-dump-row-to-payload";
import { CrshmAppHeader } from "@/components/CrshmAppHeader";
import { DemoDashboardShell } from "@/components/demo/demo-dashboard-shell";
import { DemoOrdersPreview, DemoProfilePreview } from "@/components/account/demo-account-previews";
import { SignInForm } from "@/components/sign-in/sign-in-form";
import { DashboardClient } from "@/components/dashboard/dashboard-client";
import { useSession } from "@/session/session-context";

function SignInFormFallback() {
  return (
    <div className="mt-8 min-h-[200px] rounded-xl border border-zinc-200 bg-zinc-50/80 px-4 py-8 text-center text-sm text-zinc-500">
      Loading sign-in…
    </div>
  );
}

function DashboardFallback() {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-2 px-4 text-center text-zinc-600">
      <p className="text-sm font-medium">Loading your dashboard…</p>
      <p className="max-w-md text-xs text-zinc-500">
        After auth is connected, this will load your saved Do or Dump row — not a one‑off link.
      </p>
    </div>
  );
}

export function HomeScreen() {
  const { user, loading } = useSession();
  if (loading) {
    return <div className="min-h-dvh bg-[#faf8ff]" />;
  }
  return (
    <div className="flex min-h-dvh flex-col bg-[#faf8ff] text-zinc-900">
      <CrshmAppHeader email={user?.email ?? null} />
      <WaitlistLanding />
    </div>
  );
}

export function SignInScreen() {
  useEffect(() => {
    document.title = "Sign in · crshm";
  }, []);
  return (
    <div className="mx-auto max-w-md px-4 py-16 sm:px-6">
      <h1 className="text-2xl font-black tracking-tight text-zinc-900">Sign in</h1>
      <p className="mt-3 text-sm leading-relaxed text-zinc-600">
        Sign in with the email and password you set after <strong>Do or Dump</strong>. New here? Complete Do or Dump first — we’ll email
        you to confirm your address and choose a password.
      </p>
      <Suspense fallback={<SignInFormFallback />}>
        <SignInForm />
      </Suspense>
    </div>
  );
}

export function DoOrDumpScreen() {
  useEffect(() => {
    document.title = "Do or Dump · crshm";
  }, []);
  return <DoOrDump />;
}

export function DashboardScreen() {
  return (
    <Suspense fallback={<DashboardFallback />}>
      <DashboardClient />
    </Suspense>
  );
}

export function DemoHomeScreen() {
  const payload = buildPreviewDoOrDumpDashboardPayload();
  return <DemoDashboardShell payload={payload} />;
}

export function DemoProfileScreen() {
  return <DemoProfilePreview />;
}

export function DemoOrdersScreen() {
  return <DemoOrdersPreview />;
}
